export default [
  {
    path: '',
    name: 'store location list',
    component: () => import('@/views/app/store-location/page-list.vue'),
    meta: { title: 'Daftar Lokasi Toko' },
  },
]
